import React, { useEffect, useState } from 'react';
import { Card, Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useOutletContext } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';

import OfferLetter from './OfferLetter';
import OfferConfirmation from './OfferConfirmation';
import JoiningDetails from './JoiningDetails';
import JoiningRequest from './JoiningRequest';
import JoiningConfirmation from './JoiningConfirmation';
import OfferRejected from './OfferRejected';
import ThankYou from './ThankYou';
import { sendStatusMsg } from '../../redux/actions/StatusAction';
import Declined from './Declined';
import { decrypt } from '../../util/Security';
import RejectConfirmation from './RejectConfirmation';

const Status = () => {
  const [mobileView] = useOutletContext();
  const dispatch = useDispatch();
  const currentStatus = useSelector((state) => state?.candidateState.candidateInfo.info);
  const errorHandler = useErrorHandler();
  const loggedIn = localStorage.getItem('login');
  const [status, setStatus] = useState({
    currentStatus: currentStatus,
  });

  const [popupModal, setPopupModal] = useState({
    open: false,
    type: '',
  });
  useEffect(() => {
    setStatus({ currentStatus: currentStatus });
  }, [currentStatus]);

  const styleBox = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    boxShadow: 24,
    p: 4,
    borderRadius: 1,
  };

  const modalClose = {
    position: 'absolute',
    right: 5,
    top: 5,
    color: 'red',
  };

  const handlePopupClose = () => {
    setPopupModal({
      open: false,
      type: '',
    });
  };
  const handleRejection = (reason) => {
    const { candidateId } = decrypt(loggedIn);
    let msg = { candidate_id: candidateId, comment: reason };
    if (status.currentStatus === 'Offer Declined') {
      msg = { ...msg, status: 'l_offer_declined' };
      dispatch(sendStatusMsg(msg));
      setStatus({
        currentStatus: 'Declined',
      });
    }
    if (status.currentStatus === 'Offer declined after Accepted') {
      msg = { ...msg, status: 'n_offer_declined_accept' };
      dispatch(sendStatusMsg(msg));
      setStatus({
        currentStatus: 'Declined',
      });
    }
    if (status.currentStatus === 'Declined after Joining Confirm') {
      msg = { ...msg, status: 'p_offer_declined_joining_confirmed' };
      dispatch(sendStatusMsg(msg));
      setStatus({
        currentStatus: 'Declined',
        comment: '',
      });
    }
  };

  const handleConfirmation = (type) => {
    const { candidateId } = decrypt(loggedIn);
    let msg = { candidate_id: candidateId, comment: '' };
    try {
      if (type === 'Offer Accepted') {
        msg = { ...msg, status: 'm_offer_accepted' };
        dispatch(sendStatusMsg(msg));
        setStatus({
          currentStatus: 'Offer Accepted',
        });
      }
      if (type === 'Joining Confirmed') {
        msg = { ...msg, status: 'o_joining_confirmed' };
        dispatch(sendStatusMsg(msg));
        setStatus({
          currentStatus: 'Joining Confirmed',
        });
        setPopupModal({ ...popupModal, open: true, type: 'thank_you' });
      }
      handlePopupClose();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Card sx={{ mx: mobileView ? 4 : 8, my: 4, p: 2, textAlign: 'center' }}>
        {status?.currentStatus === 'Offer Issued' ? (
          <OfferLetter
            onAccept={() => setPopupModal({ open: true, type: 'offer_acceptance' })}
            onReject={() => setPopupModal({ open: true, type: 'rejected' })}
          />
        ) : status?.currentStatus === 'Offer Accepted' ? (
          <JoiningDetails
            onAccept={() => setPopupModal({ open: true, type: 'joining_confirmation' })}
            onRequest={() => {}}
            onReject={() => setPopupModal({ open: true, type: 'rejected_after_accepted' })}
          />
        ) : status.currentStatus === 'Offer Declined' ||
          status.currentStatus === 'Offer declined after Accepted' ||
          status.currentStatus === 'Declined after Joining Confirm' ? (
          <OfferRejected mobileView={mobileView} onConfirm={(reason) => handleRejection(reason)} />
        ) : status.currentStatus === 'Joining Confirmed' ? (
          <ThankYou
            onReject={() => setPopupModal({ open: true, type: 'rejected_after_confirmed' })}
          />
        ) : (
          <Declined />
        )}
      </Card>

      {/*  Modal  */}
      <Modal open={popupModal.open} onClose={handlePopupClose}>
        <Box sx={styleBox} width={mobileView ? 250 : 400}>
          <IconButton sx={modalClose} onClick={handlePopupClose}>
            <CloseIcon />
          </IconButton>
          {popupModal.type === 'offer_acceptance' ? (
            <OfferConfirmation
              onSubmit={() => handleConfirmation('Offer Accepted')}
              onClose={handlePopupClose}
            />
          ) : popupModal.type === 'joining_confirmation' ? (
            <JoiningConfirmation
              onSubmit={() => handleConfirmation('Joining Confirmed')}
              onClose={handlePopupClose}
            />
          ) : popupModal.type === 'thank_you' ? (
            <ThankYou onClose={handlePopupClose} mobileView={mobileView} />
          ) : popupModal.type === 'rejected' ? (
            <RejectConfirmation
              onSubmit={() => setStatus({ currentStatus: 'Offer Declined' })}
              onClose={handlePopupClose}
            />
          ) : popupModal.type === 'rejected_after_accepted' ? (
            <RejectConfirmation
              onSubmit={() => setStatus({ currentStatus: 'Offer declined after Accepted' })}
              onClose={handlePopupClose}
            />
          ) : popupModal.type === 'rejected_after_confirmed' ? (
            <RejectConfirmation
              onSubmit={() =>
                setStatus({
                  currentStatus: 'Declined after Joining Confirm',
                })
              }
              onClose={handlePopupClose}
            />
          ) : null}
        </Box>
      </Modal>
    </>
  );
};

export default Status;
